export const CMS_DATA_LOAD = 'cms/CMS_DATA_LOAD';
export const CMS_DATA_SUCCESS = 'cms/CMS_DATA_SUCCESS';
export const CMS_DATA_FAIL = 'cms/CMS_DATA_FAIL';
export const CLEAR_CMS_DATA = 'cms/CLEAR_CMS_DATA';
